<template>
  <span>
    <span v-if="this.column.displayValue && this.column.displayValue !== null" v-html="displayValue"></span>
    <span v-else-if="value && titleColumn" v-for="(item, index) in value" :key="index" class="column">
      <span class="text-primary">{{ item | relationLabel(titleColumn) }}</span>
      <span v-if="subtitleColumn" class="text-grey-5 q-caption">
        {{ item | relationLabel(subtitleColumn) }}
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'grid-cell-relation-many',
  props: {
    column: {
      required: true,
      type: Object
    },
    row: Object,
    value: {
      required: true
    }
  },

  computed: {
    displayValue () {
      if (this.column.displayValue && this.column.displayValue !== null) {
        if (typeof this.column.displayValue === 'function') {
          return this.column.displayValue(this.value, this.row)
        }
      }
    },
    namespace () {
      return this.column && this.column.relation && this.column.relation.namespace
        ? this.column.relation.namespace
        : undefined
    },
    titleColumn () {
      return this.namespace ? this.$store.getters[`${this.namespace}/titleColumn`] : undefined
    },
    subtitleColumn () {
      return this.namespace ? this.$store.getters[`${this.namespace}/subtitleColumn`] : undefined
    }
  }
}
</script>
